export default __webpack_public_path__ + "static/media/right.4634ca9d.svg";